export const KK = {
  "Open document": "ÒÒ±Ð¶Ð°ÑÑÑ Ð°ÑÑ",
  "Upload file": "Ð¤Ð°Ð¹Ð»Ð´Ñ Ð¶Ò¯ÐºÑÐµÑ",
  "Drop file here to upload": "Ð¤Ð°Ð¹Ð»Ð´Ñ Ð¶Ò¯ÐºÑÐµÑ Ò¯ÑÑÐ½ Ð¾ÑÑ Ð¶ÐµÑÐ³Ðµ ÒÐ¾Ð¹ÑÒ£ÑÐ·",
  "Disc": "ÐÐ¸ÑÐº",
  "URL": "URL",
  "FILE": "Ð¤ÐÐÐ",
  "SIZE": "SIZE",
  "MB": "ÐÐ",
  "KB": "ÐÐ",
  "Bytes": "ÐÐ°Ð¹Ñ",
  "Loading... Please wait.": "ÐÒ¯ÐºÑÐµÐ»ÑÐ´Ðµ ... ÐÒ¯ÑÐµ ÑÒ±ÑÑÒ£ÑÐ·.",
  "Fit Width": "ÐÐ½Ñ ÑÓÐ¹ÐºÐµÑ",
  "Fit Height": "Ð¡ÓÐ¹ÐºÐµÑ Ð±Ð¸ÑÐºÑÑÐº",
  "Password protected document": "ÒÒ±Ð¿Ð¸Ñ ÑÓ©Ð·Ð±ÐµÐ½ ÒÐ¾ÑÒÐ°Ð»ÒÐ°Ð½ ÒÒ±Ð¶Ð°Ñ",
  "Password": "ÒÒ±Ð¿Ð¸Ñ ÑÓ©Ð·",
  "Open": "ÐÑÑÒ",
  "Password Required": "ÒÒ±Ð¿Ð¸Ñ ÑÓ©Ð· ÒÐ°Ð¶ÐµÑ",
  "Incorrect password": "ÒÐ°ÑÐµ ÒÒ±Ð¿Ð¸ÑÑÓ©Ð·",
  "Error": "ÒÐ°ÑÐµ",
  "Something went wrong": "ÐÑÑÐ´ÐµÒ£Ðµ Ð´Ò±ÑÑÑ Ð±Ð¾Ð»Ð¼Ð°Ð´Ñ",
  "Server is not available": "Ð¡ÐµÑÐ²ÐµÑ ÒÐ¾Ð» Ð¶ÐµÑÑÐ¼Ð´Ñ ÐµÐ¼ÐµÑ",
  "of": "Ð½ÑÒ£",
  "Please wait...": "Ó¨ÑÑÐ½ÐµÐ¼ÑÐ½ ÐºÒ¯ÑÐµ ÑÒ±ÑÑÒ£ÑÐ·..."
};
